var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
/** Uma aba da area. */
let CompanyTabScope = class CompanyTabScope extends Scope {
    constructor() {
        super(...arguments);
        this.key = 'usuarios';
        this.label = '';
        /** Quantos itens a aba tem, quando o numero muda a decisao de ir ate ela. */
        this.badge = 0;
        this.active = false;
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyTabScope.prototype, "key", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyTabScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyTabScope.prototype, "badge", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyTabScope.prototype, "active", void 0);
CompanyTabScope = __decorate([
    Observable
], CompanyTabScope);
export { CompanyTabScope };
/** Um administrador ou profissional da empresa. */
let CompanyUserScope = class CompanyUserScope extends Scope {
    constructor() {
        super(...arguments);
        this.name = '';
        this.email = '';
        this.cpf = '';
        /**
         * Se o CPF foi fabricado a partir do CNPJ.
         *
         * A tela o marca porque ali cabe uma correcao - e porque um CPF que nao e de
         * ninguem, sem aviso, passa por identidade de verdade.
         */
        this.cpfFicticio = false;
        /** `Administrador`, `Profissional` ou os dois - o papel nao e exclusivo. */
        this.papel = '';
        /**
         * Se administra ESTA empresa - o que a tela destaca.
         *
         * Quem administra decide quem entra, quem sai e o que cada um enxerga. Numa lista
         * em que toda linha parece igual, descobrir quem tem esse poder exige ler a coluna
         * de papel pessoa por pessoa.
         */
        this.administrador = false;
        /** O administrador master da empresa (B-30) - marcado na linha. */
        this.master = false;
        /** Se quem esta logado pode desligar esta pessoa - sem isso, a acao nao aparece. */
        this.podeAlterarAcesso = false;
        /** Quantos colaboradores DESTA empresa o profissional acompanha. */
        this.atribuidos = 0;
        this.profissional = false;
        /**
         * Quando entrou pela ultima vez - `12/09/2026` -, ou vazio quando nunca entrou.
         *
         * A plataforma nao guarda historico de acesso: o que existe e o token da ultima sessao.
         * Numa lista de quem administra e atende, isto e o que separa a conta viva da conta que
         * alguem criou e ninguem usa.
         */
        this.ultimoAcesso = '';
        /** Abre a ficha - uma porta so para tudo o que se configura nesta pessoa. */
        this.onOpen = Scope.ASYNC_ACTION;
        this.onRemove = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserScope.prototype, "name", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserScope.prototype, "email", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserScope.prototype, "cpf", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserScope.prototype, "cpfFicticio", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserScope.prototype, "papel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserScope.prototype, "administrador", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserScope.prototype, "master", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserScope.prototype, "podeAlterarAcesso", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserScope.prototype, "profissao", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserScope.prototype, "atribuidos", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserScope.prototype, "profissional", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserScope.prototype, "ultimoAcesso", void 0);
CompanyUserScope = __decorate([
    Observable
], CompanyUserScope);
export { CompanyUserScope };
/** Um pedido de vinculo esperando decisao. */
let CompanyLinkScope = class CompanyLinkScope extends Scope {
    constructor() {
        super(...arguments);
        this.name = '';
        this.cpf = '';
        this.email = '';
        /** `16/09/2026 - 17:55`, quando a pessoa pediu. */
        this.requestedAt = '';
        this.onApprove = Scope.ASYNC_ACTION;
        this.onReject = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyLinkScope.prototype, "name", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyLinkScope.prototype, "cpf", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyLinkScope.prototype, "email", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyLinkScope.prototype, "requestedAt", void 0);
CompanyLinkScope = __decorate([
    Observable
], CompanyLinkScope);
export { CompanyLinkScope };
/** Uma coluna de uma das duas tabelas, na ordem que a pessoa arrastou. */
let CompanyUsersColumnScope = class CompanyUsersColumnScope extends Scope {
    constructor() {
        super(...arguments);
        this.field = '';
        this.label = '';
        /** Se arrasta para outro lugar - todas, menos o nome e a de acoes. */
        this.movable = false;
        /** Outra coluna, `source`, foi solta sobre esta. */
        this.onDrop = () => undefined;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUsersColumnScope.prototype, "field", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUsersColumnScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUsersColumnScope.prototype, "movable", void 0);
CompanyUsersColumnScope = __decorate([
    Observable
], CompanyUsersColumnScope);
export { CompanyUsersColumnScope };
/**
 * A area em que a empresa administra os proprios usuarios e decide quem entra.
 *
 * As duas abas vivem no mesmo lugar de proposito: sao a mesma pergunta - "quem faz
 * parte desta empresa" - em dois momentos. Uma decide quem entra; a outra, quem
 * administra e quem acompanha.
 *
 * O que se faz a partir daqui - cadastrar, corrigir um CPF, atribuir colaboradores -
 * nao mora neste scope: sao places FILHOS, desenhados por cima. Um dialogo aberto e
 * um lugar onde o leitor esta, e assim ele sobrevive ao F5 e fecha no Voltar.
 */
let CompanyUsersScope = class CompanyUsersScope extends Scope {
    constructor() {
        super(...arguments);
        /** As colunas de cada tabela, na ordem escolhida, e a geometria que o modelo decide. */
        this.userColumns = [];
        this.linkColumns = [];
        this.loading = true;
        this.companyChooser = false;
        /**
         * Se falta escolher a empresa - e, com isso, se ha lista para mostrar.
         *
         * Vem do PRESENTER, e nao de perguntar ao seletor se ha algo escolhido. Os dois
         * ja discordaram: o seletor guarda o que foi clicado e o presenter le o endereco,
         * e chegar em `#/hub/company-users` sem parametro com o seletor ainda mostrando a
         * ultima empresa desenhava uma tabela vazia no lugar do convite a escolher.
         */
        this.needsCompany = false;
        this.tabs = [];
        this.tab = 'usuarios';
        this.users = [];
        /**
         * Quantos da equipe entraram no painel nos ultimos 30 dias, e de quantos.
         *
         * Veio de Adocao e Engajamento em 23/09/2026. La ele contava CONTAS numa tela que fala
         * de colaboradores, e mudava de populacao conforme o filtro de empresa: sem empresa
         * escolhida contava todo mundo - inclusive quem administra a plataforma -, com empresa
         * passava a exigir ficha. Tres quartos do numero eram login de APP, de colaborador.
         *
         * Aqui a populacao e uma so e e a da tela: quem administra ou atende esta empresa. E o
         * numero e contado das LINHAS que a tela mostra, entao ele nao tem como discordar delas.
         */
        this.acessosRecentes = 0;
        this.acessosTotal = 0;
        this.links = [];
        /**
         * Se quem esta logado cadastra administrador nesta empresa: o master dela, ou a
         * plataforma (B-30). Os outros administradores nao veem o botao.
         */
        this.podeCadastrarAdministrador = false;
        /**
         * O aviso para o administrador que NAO e master, dizendo quem e - ou que a empresa
         * esta sem nenhum. Vazio para quem pode agir: a ele a regra nao muda nada na tela.
         */
        this.avisoMaster = '';
        /**
         * As tentativas de entrar no painel recusadas enquanto a empresa estava bloqueada.
         *
         * So para o administrador principal (o master) e para a plataforma - e o servidor so
         * as entrega ao master depois que a empresa foi liberada (decisao de 08/10/2026).
         * Vazio para os demais, e para a empresa que nunca foi bloqueada.
         */
        this.blockedAttempts = [];
        this.onNewAdmin = Scope.ASYNC_ACTION;
        this.onNewProfessional = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Array)
], CompanyUsersScope.prototype, "userColumns", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CompanyUsersScope.prototype, "linkColumns", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], CompanyUsersScope.prototype, "userLayout", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], CompanyUsersScope.prototype, "linkLayout", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUsersScope.prototype, "loading", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUsersScope.prototype, "error", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], CompanyUsersScope.prototype, "companySelector", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUsersScope.prototype, "companyChooser", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUsersScope.prototype, "needsCompany", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CompanyUsersScope.prototype, "tabs", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUsersScope.prototype, "tab", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CompanyUsersScope.prototype, "users", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUsersScope.prototype, "acessosRecentes", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUsersScope.prototype, "acessosTotal", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CompanyUsersScope.prototype, "links", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUsersScope.prototype, "podeCadastrarAdministrador", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUsersScope.prototype, "avisoMaster", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CompanyUsersScope.prototype, "blockedAttempts", void 0);
CompanyUsersScope = __decorate([
    Observable
], CompanyUsersScope);
export { CompanyUsersScope };
//# sourceMappingURL=company-users.scope.js.map